export const styles = theme => ({
    accordionDetails: {
        backgroundColor: "white"
    },
    section: {
        marginBottom: "20px",
        width: "100%"
    }
});
